<template>
  <MyVacanciesList
    api-query-path="/api/cabinet/vacancies-hidden"
    :sort="sort"
    @show-vacancy="$emit('show-vacancy')"
  />
</template>

<script>
import MyVacanciesList from "@/components/MyVacanciesList";

export default {
  name: 'AccountHiddenVacanciesPage',
  components: {
    MyVacanciesList,
  },
  props: {
    sort: {
      type: String,
      required: true,
    },
  },
};
</script>
